import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { CustomPattern } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { CookiesService } from 'src/app/services/cookies.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { PolicyManagementService } from 'src/app/services/dataLayer/CAM/policy-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { PolicyContentService } from '../../services/policy-content.service';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { NgSelectComponent, NgOptionTemplateDirective, NgLabelTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatIcon } from '@angular/material/icon';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { TravelCategoryComponent } from '../travel-category/travel-category.component';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
@Component({
  selector: 'app-policy-configuration',
  templateUrl: './policy-configuration.component.html',
  styleUrls: ['./policy-configuration.component.scss'],
  imports: [ReactiveFormsModule, MatFormField, MatLabel, MatInput, NgIf, MatError, MatRadioGroup, MatRadioButton, NgSelectComponent, AutoBlurSelectDirective, MatIcon, NgOptionTemplateDirective, MatCheckbox, FormsModule, NgLabelTemplateDirective, MatButton, MatProgressSpinner, CdkScrollable, MatDialogContent, TravelCategoryComponent]
})
export class PolicyConfigurationComponent implements OnInit, OnDestroy {
  policyConfigForm: FormGroup;
  isTravelOpen = false;
  commonObj: any = {
    travelCategoryVisible: false,
    GetRuleAppliesOnPlaceholder: "",
    isSubmitting: false,
    AssociatedWithBranch: 0,
    travelerSearchLength: ""
  }
  commonObjPipes: any = {
    TravelCategory: { pipe: [], all: [] },
    GetAllMultiTravelerDetails: { pipe: [], all: [] },
    GetRuleAppliesOn: { pipe: [], all: [] },
    AssociatedWithBranch: { pipe: [], all: [] },
    AssociateedWithBranchIni: { pipe: [], all: [] },
    GetProdectData: { pipe: [], all: [] },
    AssociatedWithBranchArray: { pipe: [], all: [] },
    1: { pipe: [], all: [] },//1
    2: { pipe: [], all: [] },//2
    3: { pipe: [], all: [] },//3
    4: { pipe: [], all: [] },//4
    5: { pipe: [], all: [] },//5
    6: { pipe: [], all: [] },//6
  }
  policyList: any
  private readonly destroy$ = new Subject<void>();
  content: any;
  dictionaryContent:any;
  constructor(private readonly _FormBuilder: FormBuilder, private readonly _CamApiService: CamService, public readonly _ApiService: ApiService, private readonly _MatDialog: MatDialog, public readonly _CommonService: CommonService, private readonly _CryptoService: CryptoService, private readonly _Router: Router, private readonly _ToastrApiService: ToastrApiService, private readonly _ActivatedRoute: ActivatedRoute, private readonly _PolicyManagementService: PolicyManagementService, private readonly _CompanyManagementService: CompanyManagementService, private readonly _CookiesService: CookiesService, private readonly policyContentService: PolicyContentService,private readonly dictionaryContentService: DisctionaryContent) {
    this.policyConfigForm = this._FormBuilder.group({
      saUserId: this._CryptoService.getValueFromKey('USERID'),
      TravelPolicyId: 0,
      TravelPolicyTitle: ['', [Validators.required, Validators.pattern(CustomPattern.ONLY_ALPHA), Validators.minLength(3), Validators.maxLength(100)]],
      TravelPurpose: ['BTC', [Validators.required]],
      CallFor: 'insert',
      AssociatedWithBranchId: null,
      policyflow: this._FormBuilder.group({
        id: 0,
        TravelPolicy: '',
        TravelCategory: [null, Validators.required],
        productCode: [null, Validators.required],
        appliedOn: [null, Validators.required],
        AppliedFor: null,
      })
    });
  }

  ngOnInit() {
    this.policyContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
          this.dictionaryContent = res;
    });
    if (this._ActivatedRoute.snapshot.queryParams['enc']) {
      this.commonObj.id = this._CryptoService.decryptData(this._ActivatedRoute.snapshot.queryParams['enc'])?.policyID;
      this._CamApiService.getPolicyManagementByID(this.commonObj.id).then(($: any) => {
        if ($.data?.[10].Branchlist?.length) {
          let form = $.data?.[10].Branchlist[0];
          this.commonObj.AssociatedWithBranch = form.AssociatedWithBranch_Id || Number(form.AppliedOn);
          this.policyConfigForm.get("TravelPolicyId")?.setValue(form.TravelPolicy_Id ?? "");
          this.policyConfigForm.get("TravelPolicyTitle")?.setValue(form.TravelPolicy_Title ?? "");
          this.policyConfigForm.get("TravelPurpose")?.setValue(form.TravelPurpose ?? "");
          this.policyConfigForm.get("CallFor")?.setValue("4")
          this.policyConfigForm.get("AssociatedWithBranchId")?.setValue(form.AssociatedWithBranch_Id ? form.AssociatedWithBranch_Id.split(",").map(Number) : "");
          const categoryVal = form.TravelCategory_ID ?? form.TravelCategory_Id ?? form.TravelCategoryId ?? form.TravelCategory ?? null;
          this.policyConfigForm.get("policyflow.TravelCategory")?.setValue(categoryVal ? Number(categoryVal) || null : null);
          this.policyConfigForm.get("policyflow.productCode")?.setValue("AIR ");
          const appliedOnValue = form.AppliedOn ? Number(form.AppliedOn) : null;
          this.policyConfigForm.get("policyflow.appliedOn")?.setValue(appliedOnValue);
          this.policyConfigForm.get("policyflow.AppliedFor")?.setValue(form.AppliedFor ? form.AppliedFor?.split(",")?.map(Number) ?? null : null);
        }
        this.getMultiTravelerList(true, $.data?.[10]?.Branchlist?.[0] ?? {});
        this.getTravelCategory();
      })
    } else {
      this.getMultiTravelerList();
      this.getTravelCategory();
    }
    this._CommonService.travelCategoryAddTrigger.subscribe(($: any) => {
      if ($?.isSaved) {
        this.commonObj.travelCategoryVisible = false;
        this.CloseDialog(true);
        this.getTravelCategory($);
      }
      if ($?.isCancel) {
        this.commonObj.travelCategoryVisible = false;
        this.CloseDialog(true);
      }
    })


    //GTM use
    this._PolicyManagementService.policyListValue.subscribe((result: any) => {

      this.policyList = result
    })

    this._PolicyManagementService.page_landing('Policy Management - Policy Configuration', this.policyList.length, 'Policy Management Workflow')//GTM use


  }


  getTravelCategory($?: any) {
    this._CamApiService.getTravelCategoryOld().then(($category: any) => {
      console.log($category)
      this.bindLists("TravelCategory", $category.data.filter(($: any) => $.Status));
      if ($?.isSaved) {
        let travelCategory = JSON.parse(this._ApiService.getSession("policyTravelCategory")) ?? {};
        let code = $category.data.find(($catFind: any) => $catFind.TravelCategoryCode === travelCategory.travelCategoryCode && $catFind.TravelCategory === travelCategory.travelCategoryName && $catFind.TravelCategoryType === travelCategory.travelCategoryType);
        if (code?.TravelCategory_ID && travelCategory.applyTravelPolicy) {
          sessionStorage.setItem("policyTravelCategory", code?.TravelCategory_ID ?? "");
          this.policyConfigForm.get("policyflow.TravelCategory")?.setValue(code.TravelCategory_ID ?? null);
        }
      }
      this.travelCategoryFilter({ value: this.policyConfigForm.value.TravelPurpose }, false);
    })
  }



  travelCategoryFilter({ value }: any, isReset: boolean = true) {
    if (isReset) {
      this.policyConfigForm.get("policyflow.TravelCategory")?.setValue(null);
      this.policyConfigForm.get("policyflow.appliedOn")?.reset();
    }
    if (value == 'GTC') {
      this.commonObjPipes.GetRuleAppliesOn.pipe = this.commonObjPipes.GetRuleAppliesOn.all.filter((item: any) => item.ID != 6)
    } else {
      this.commonObjPipes.GetRuleAppliesOn.pipe = this.commonObjPipes.GetRuleAppliesOn.all
    }

    this.commonObjPipes.TravelCategory.pipe = this.commonObjPipes.TravelCategory.all.filter(($category: any) => $category.TravelCategoryType == value);
  }

  bindLists(key: string, lists: any[]) {
    this.commonObjPipes[key].pipe = lists;
    this.commonObjPipes[key].all = lists;
  }

  CloseDialog(isClose: boolean) {
    this._MatDialog.closeAll();
    this.commonObj.travelCategoryVisible = false;
  }
  openDialog(template: TemplateRef<any>) {
    this._MatDialog.open(template, { panelClass: "seatSelectorPopup", autoFocus: false, disableClose: true }).afterOpened().subscribe(() => {
      this._CommonService.travelCategoryAddTrigger.next({ add: true, isSaved: false, TravelPurpose: this.policyConfigForm.value.TravelPurpose });
      this.commonObj.travelCategoryVisible = true;
    })
  }
  getMultiTravelerList(query: boolean = false, form: any = {}) {
    let associate = (this.commonObj.AssociatedWithBranch) || 0;
    const appliedOn = this.policyConfigForm.value.policyflow.appliedOn;
    const queryNO = appliedOn >= 0 && appliedOn ? (appliedOn - 1) : 2;
    let travelerQuery: number;
    if ([1, 6].includes(appliedOn)) {
      travelerQuery = appliedOn;
    } else {
      travelerQuery = (queryNO + 1) !== 2 ? queryNO : 2;
    }
    this._CamApiService.getMultiTraveler(this._CryptoService.getValueFromKey('USERID') as string, (typeof this.commonObj.AssociatedWithBranch === 'object' ? 0 : associate), travelerQuery).then((res: any) => {
      if (res.status == "Success") {

        res.data.GetRuleAppliesOn.forEach(($: any) => {
          if ($.Name === 'Corporate-Branch') {
            $.Name = 'Corporate-Office location';
          }
        });

        res.data.GetAllMultiTravelerDetails.forEach(($multi: any) => {
          const appliedOnMatch = res.data.GetRuleAppliesOn.find(($app: any) => $app.ID == $multi.AppliedOn);
          $multi.AppliedOnName = appliedOnMatch?.Name;
        })
        res.data?.GetBranchData?.forEach((rec: any) => {
          rec.ID = rec.SA_Branch_ID;
          rec.Name = rec.Branch_Name;
          delete rec.SA_Branch_ID;
          delete rec.Branch_Name;
        })
        res.data.AssociatedWithBranch.forEach(($: any) => {
          $.name = ($.Name || $.name);
          $.ID = +$.ID;
        });
        res.data.Table_10.forEach(($: any) => {
          let [name, email] = $?.Name?.split("(") ?? ["", ""];
          $.name = name || $.Name;
          $.ID = +$.ID;
          $.email = String(email || "")?.replace(")", "");
        });
        res.data.GetProdectData.forEach(($: any) => {
          $.Product_Name = ($.Product_Name ?? $.Branch_Name)
          $.Product_code = ($.Product_code ?? $.SA_Branch_ID)
        });
        this.bindLists('GetAllMultiTravelerDetails', res.data.GetAllMultiTravelerDetails);

        this.bindLists('GetRuleAppliesOn', res.data.GetRuleAppliesOn);

        if (query && this.policyConfigForm.value.TravelPurpose == 'GTC') {
          this.commonObjPipes.GetRuleAppliesOn.pipe = this.commonObjPipes.GetRuleAppliesOn.all.filter((item: any) => item.ID != 6)
        } else {
          this.commonObjPipes.GetRuleAppliesOn.pipe = this.commonObjPipes.GetRuleAppliesOn.all
        }

        if ([1, 6].includes(this.policyConfigForm.value.policyflow.appliedOn)) {
          this.bindLists('AssociatedWithBranch', res.data.Table_10 ?? []);
        } else {
          this.bindLists('AssociatedWithBranch', res.data.AssociatedWithBranch ?? []);
        }
        const appliedOnValue = form?.AppliedOn ?? this.policyConfigForm.value.policyflow.appliedOn;
        this.bindLists('GetProdectData', Number(appliedOnValue) !== 6 ? res.data.GetProdectData : res.data.AssociatedWithBranch);
        this.bindLists('2', res.data.GetBranchData);
        this.bindLists('3', res.data.GetdepartmentData);
        this.bindLists('4', res.data.GetDesignationData);
        this.bindLists("5", res.data.GetGradeData);
        this.bindLists("6", res.data.GetAllMultiTravelerDetails);
        this.commonObj.GetRuleAppliesOnPlaceholder = this.commonObjPipes.GetRuleAppliesOn.pipe.find(($on: any) => $on.ID === this.policyConfigForm.value?.policyflow?.appliedOn)?.Name ?? "";
      }
      this.clearance(3);
    });
  }
  onChangeRuleAppliedOn(event: any) {
    this.commonObj.AssociatedWithBranch = event?.ID ?? event;
    this.getMultiTravelerList(this.policyConfigForm.value.TravelPurpose == 'GTC');

  }
  onCheckboxChange(item: any) {
    this.commonObj.AssociatedWithBranch = item.map(($: any) => $.ID).join(",");
    this.commonObj.GetRuleAppliesOnPlaceholder = this.commonObjPipes.GetRuleAppliesOn.pipe.find(($on: any) => $on.ID === this.policyConfigForm.value?.policyflow?.appliedOn)?.Name ?? "";
    const appliedOn = this.policyConfigForm.value.policyflow.appliedOn;
    const queryNO = appliedOn >= 0 && appliedOn ? (appliedOn - 1) : 2;
    const travelerQuery = [1, 6].includes(appliedOn) ? appliedOn : queryNO;
    this._CamApiService.getMultiTraveler(this._CryptoService.getValueFromKey('USERID') as string, this.commonObj.AssociatedWithBranch, travelerQuery).then((res: any) => {
      if (res.status == "Success") {
        res.data.AssociatedWithBranch.forEach(($: any) => { $.name = ($.Name ?? $.name) });
      };
      this.bindLists('AssociatedWithBranch', res.data.AssociatedWithBranch);
    })
  }
  clearance(level: number) {
    if (level === 1) {
      this.policyConfigForm.get("AssociatedWithBranchId")?.reset();
      this.policyConfigForm.get("policyflow.AppliedFor")?.reset();
      this.bindLists('AssociatedWithBranch', []);
    } else if (level === 2) {
      this.policyConfigForm.get("policyflow.AppliedFor")?.reset();
    }
    if ([2].includes(this.policyConfigForm.value.policyflow.appliedOn)) {
      this.policyConfigForm.get("policyflow.AppliedFor")?.removeValidators([Validators.required]);
    } else {
      this.policyConfigForm.get("policyflow.AppliedFor")?.setValidators([Validators.required]);
    }
    const appliedOn = this.policyConfigForm.value?.policyflow?.appliedOn;
    const hasPipeData = this.commonObjPipes?.[appliedOn]?.pipe?.length > 0;
    if (hasPipeData && ![1, 6].includes(appliedOn)) {
      this.policyConfigForm?.get("AssociatedWithBranchId")?.setValidators([Validators.required]);
    } else {
      this.policyConfigForm?.get("AssociatedWithBranchId")?.removeValidators([Validators.required]);
    }
    this.policyConfigForm?.get("AssociatedWithBranchId")?.updateValueAndValidity();
    this.policyConfigForm?.get("policyflow.AppliedFor")?.updateValueAndValidity();
  }
  save() {
    if (this.policyConfigForm.valid) {
      this.commonObj.isSubmitting = true;
      let copy = structuredClone(this._CommonService.removeNull(this.policyConfigForm.value)) as any;
      copy.policyflow.AppliedFor = (copy.policyflow.AppliedFor?.length ? copy.policyflow.AppliedFor : []).join(",");
      copy.AssociatedWithBranchId = (copy.AssociatedWithBranchId?.length ? copy.AssociatedWithBranchId : []).join(",");
      copy.policyflow.appliedOn = String(copy.policyflow.appliedOn);
      copy.policyflow.TravelCategory = String(copy.policyflow.TravelCategory);
      if ([2].includes(+copy.policyflow.appliedOn)) {
        copy.policyflow.AppliedFor = copy.AssociatedWithBranchId;
      }
      this._CamApiService.postConfiguration(copy).then(($: any) => {

        const isUpdate = this.policyConfigForm.value.TravelPolicyId > 0;

        this._ToastrApiService.show('success', `Policy configuration has been ${isUpdate ? 'updated' : 'saved'} successfully!`);
        this._PolicyManagementService.save_success('Policy configuration', 'Save')//GTM use

        this.commonObj.isSubmitting = false;
        this._Router.navigate(["/cam/policy-management/policy-criteria"], {
          queryParams: { enc: this._CryptoService.encryptData({ policyID: $?.data?.policyId }) }
        })
      }).catch((e) => {
        this._PolicyManagementService.view_error_message(e?.error?.message, e?.error?.code);
        this._ToastrApiService.show('error', e.error.message);
        this.commonObj.isSubmitting = false;
      })
    }

    //GTM use
    const obj = {
      list: this.commonObjPipes,
      form: this.policyConfigForm.value,
    }
    this._PolicyManagementService.policy_configuration_save('Policy Configuration Page', 'Save', obj)//GTM use
    this._CookiesService.setData(this.policyConfigForm.value.TravelPolicyTitle)//GTM use
  }
  safeDuration(input: any): [number, number] | null {
    if (typeof input === 'string') {
      return input.split('.').map(Number) as [number, number];
    }
    return null;
  }
  navigateToList() {
    this._PolicyManagementService.policy_configuration_Cancel('Policy Configuration Page', 'Cancel')//GTM use
    this._CamApiService.resetPolicyFormsMode();
    this._Router.navigate(["cam", "policy-management"]);
  }
  onTravelerSearch(event: any) {
  }
  ngOnDestroy() {
    if (!(globalThis.location.href.includes("policy-configuration"))) {
      sessionStorage.removeItem("policyTravelCategory");
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
